var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.shown)),(_vm.active)?_c('span',{staticClass:"typed-text__cursor cursor"},[_vm._v("_")]):_vm._e(),_c('span',{staticClass:"typed-text__rest"},[_vm._v(_vm._s(_vm.rest))])])
}
var staticRenderFns = []

export { render, staticRenderFns }